export default __webpack_public_path__ + "static/5-32668d35644c914f6bbc22f67ffdccb5.jpeg";